import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a4a19f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-10 flex justify-center" }
const _hoisted_2 = { class: "col-md-8 col-xxl-8" }
const _hoisted_3 = { class: "card custom-card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "card-title" }, "WALLET", -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "w-100 text-center mt-10" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("DEPOSIT ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-down" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" ADD TO STAKING ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-down" }, null, -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  class: "card custom-card",
  style: {"margin-top":"40px"}
}
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "card-title" }, "VAULT", -1))
const _hoisted_18 = {
  key: 0,
  class: "card-title ml-5 vault-locked"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-lock" }, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Locked")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "w-100 text-center" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-up" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NFTGrid = _resolveComponent("NFTGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_NFTGrid, {
              title: "Your wallet",
              class: "flex-1",
              nfts: _ctx.desiredWalletNFTs,
              onSelected: _ctx.handleWalletSelected
            }, null, 8, ["nfts", "onSelected"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.selectedWalletNFTs.length > 0 && _ctx.farmerState !== 'staked')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary deposit-btn",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moveNFTsFE(false)))
                }, _hoisted_10))
              : _createCommentVNode("", true),
            (_ctx.selectedWalletNFTs.length > 0 && _ctx.farmerState === 'staked')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-success add-btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addToStaking()))
                }, _hoisted_13))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            (_ctx.vaultLocked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              (_ctx.selectedVaultNFTs.length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-warning withdraw-btn mb-3",
                    disabled: _ctx.vaultLocked,
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveNFTsFE(true)))
                  }, [
                    _createTextVNode(_toDisplayString(!_ctx.vaultLocked ? 'WITHDRAW' :  'END STAKING TO WITHDRAW') + " ", 1),
                    _hoisted_25
                  ], 8, _hoisted_24))
                : _createCommentVNode("", true)
            ]),
            (_ctx.bank && _ctx.vault)
              ? (_openBlock(), _createBlock(_component_NFTGrid, {
                  key: 0,
                  title: "Your vault",
                  class: "flex-1",
                  nfts: _ctx.desiredVaultNFTs,
                  onSelected: _ctx.handleVaultSelected
                }, null, 8, ["nfts", "onSelected"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}